import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import React from 'react';
import { FaAngleDown, FaAngleUp } from 'react-icons/fa';
import AnimateHeight from 'react-animate-height';
import * as S from './styles';
import { jsx as ___EmotionJSX } from "@emotion/react";
let MoreExpander = /*#__PURE__*/function (_React$Component) {
  function MoreExpander() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.state = {
      height: 0
    };
    _this.toggle = () => {
      _this.setState({
        height: _this.state.height === 0 ? 'auto' : 0
      });
    };
    return _this;
  }
  _inheritsLoose(MoreExpander, _React$Component);
  var _proto = MoreExpander.prototype;
  _proto.render = function render() {
    return ___EmotionJSX("div", null, ___EmotionJSX(S.Header, {
      height: this.state.height,
      onClick: this.toggle
    }, this.state.height !== 0 ? ___EmotionJSX(FaAngleUp, null) : ___EmotionJSX(FaAngleDown, null), this.props.title), ___EmotionJSX(AnimateHeight, {
      height: this.state.height,
      duration: 500,
      style: {
        borderBottom: `1px solid ${this.props.separatorColor}`
      }
    }, this.props.children));
  };
  return MoreExpander;
}(React.Component);
MoreExpander.defaultProps = {
  title: 'mehr erfahren...',
  separatorColor: '#efefef'
};
export default MoreExpander;